import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  ITooltip,
  TooltipType,
} from '../../services/tooltip-sequence/i2g-tooltip-sequence.data';
import { IIcon } from '../icon/icon.component';

@Component({
  selector: 'i2g-tooltip',
  styleUrls: ['./tooltip.component.scss'],
  templateUrl: './tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  @Input() closeIcon: IIcon;
  @Input() tooltip: ITooltip;
  @Input() type: TooltipType;
  @Input() showNext: boolean;
  /** A text to display the current progress. If not provided, the text is not shown  */
  @Input() progressText: string;
  /** Determines whether 'Next' is displayed or 'Done' */
  @Input() isLastInSequence: boolean;

  /**
   * A handler for when user clicks anywhere within the tooltip
   * apart from the close button
   */
  @Output() clickTooltip: EventEmitter<string> = new EventEmitter<string>();
  @Output() dismissTooltip: EventEmitter<string> = new EventEmitter<string>();
}
